import * as React from 'react';

import {Prefix} from './tooltip-prefixes';
import type {TooltipRowData} from './tooltip-types';
import {formatNumber} from './tooltip-utils';

import styles from './tooltips.module.css';

type TooltipRowProps = {
    row: TooltipRowData;
    isPaddedTop?: boolean;
    currencyPrefix: string;
};
export function TooltipRow({row, isPaddedTop, currencyPrefix}: TooltipRowProps) {
    // The `total` facet is only set for leads reports.  For other types like
    // the activity report, we can just show the count without needing a label.
    const hasTotalFacet = row.rowData.total !== null && row.rowData.total !== undefined;
    const units = row.unit;

    return (
        <tr key={row.name} className={isPaddedTop ? styles['row--padded'] : undefined}>
            <TooltipValue value={row.rowData.count} units={units} />
            {hasTotalFacet ? <Prefix currencyPrefix={currencyPrefix} /> : null}
            {hasTotalFacet ? <TooltipValue value={row.rowData.total} /> : null}
        </tr>
    );
}

type TooltipValueProps = {
    value?: number | null | undefined;
    units?: string | null | undefined;
};
export function TooltipValue({value, units}: TooltipValueProps) {
    if (value === null || typeof value === 'undefined') return <td />;
    const formattedValue = units ? `${formatNumber(value)} ${units}` : formatNumber(value);

    return <td className={styles['data-value']}>{formattedValue}</td>;
}
